import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { saveUserInfo } from "../../../../actions/action_users";
import LoadingOverlay from "../../common/LoadingOverlay";
import Header from "../../layout/Header";
import { isValid } from "date-fns";
import { saveRegisterTwoocaInput } from "../../../../actions/action_register_twooca";
import { addParamUrl } from "../../../../utils";

class RegisterTwooca extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectTo: false,
      errorMessage: "",
      loading: false,
      showErrorPopup: false,
      isValid: false,
      filteredCities: [],

      email: this.props.userInfo.email,
      emailError: "",

      lastName: "",
      lastNameError: "",
      lastNameFuri: "",
      lastNameFuriError: "",
      lastNameEn: "",
      lastNameEnError: "",

      firstName: "",
      firstNameError: "",
      firstNameFuri: "",
      firstNameFuriError: "",
      firstNameEn: "",
      firstNameEnError: "",

      middleName: "",
      middleNameError: "",
      middleNameFuri: "",
      middleNameFuriError: "",
      middleNameEn: "",
      middleNameEnError: "",

      birthday: "",
      birthdayError: "",
      tel: "",
      telError: "",
      gender: "0",
      genderError: "",
      postCode: "",
      postCodeError: "",
      prefecture: "",
      prefectureId: "",
      prefectureError: "",
      cities: [],
      city: "",
      cityId: "",
      cityError: "",
      address: "",
      addressError: "",
      building: "",
      buildingError: "",
      policy: false,
    };
    this.onInputChange = this.onInputChange.bind(this);
    this.onPrefectureChange = this.onPrefectureChange.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  onInputChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value, [name + "Error"]: "" });
  }

  onPrefectureChange(e) {
    const prefecture = this.props.prefectures.find(
      (pref) => pref.prefectureId == e.target.value
    );
    const filteredCities = this.props.cities.filter(
      (city) => city.prefCode === String(Number(e.target.value))
    );
    this.setState({
      prefecture: prefecture?.prefectureName ?? "",
      prefectureId: e.target.value,
      prefectureError: "",
      city: "",
      cityId: "",
      filteredCities: filteredCities,
    });
  }

  onCityChange(e) {
    const city = this.props.cities.find(
      (city) => city.cityId == e.target.value
    );
    this.setState({
      city: city?.cityName ?? "",
      cityId: e.target.value,
      cityError: "",
    });
  }

  loading(show) {
    this.setState({ loading: show });
  }

  valid() {
    this.setState({
      emailError: "",
      lastNameError: "",
      lastNameFuriError: "",
      lastNameEnError: "",
      firstNameError: "",
      firstNameFuriError: "",
      firstNameEnError: "",
      middleNameError: "",
      middleNameFuriError: "",
      middleNameEnError: "",
      birthdayError: "",
      telError: "",
      genderError: "",
      postCodeError: "",
      prefectureError: "",
      cityError: "",
      addressError: "",
      buildingError: "",
    });
    let valid = true;
    let value;
    const patternEmail = new RegExp(
      /^(("[\w+-\s]+")|([\w+-]+(?:\.[\w+-]+)*)|("[\w+-\s]+")([\w+-]+(?:\.[\w+-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    const patternFuri = new RegExp(/^[ァ-ヶー]+$/u);
    const patternEn = new RegExp(/^[A-Za-z\s]*$/);
    const patternPhone = new RegExp(/^(?!0{10,11}$)\d{10,11}$/);
    const patternZipcode = new RegExp(/^\d{7}$/);

    // Validate Email
    value = this.state.email.trim();
    if (value.length <= 0) {
      this.setState({
        emailError: "メールアドレスは必須項目です。",
      });
      valid = false;
    } else if (!patternEmail.test(value)) {
      this.setState({
        emailError: "メールアドレスが正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate last name
    value = this.state.lastName.trim();
    if (value.length <= 0) {
      this.setState({
        lastNameError: "姓は必須項目です。",
      });
      valid = false;
    }

    // Validate last name furi
    value = this.state.lastNameFuri.trim();
    if (value.length <= 0) {
      this.setState({
        lastNameFuriError: "姓フリガナは必須項目です。",
      });
      valid = false;
    } else if (!patternFuri.test(value)) {
      this.setState({
        lastNameFuriError: "姓フリガナが正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate last name en
    value = this.state.lastNameEn.trim();
    if (value.length <= 0) {
      this.setState({
        lastNameEnError: "姓英語表記は必須項目です。",
      });
      valid = false;
    } else if (!patternEn.test(value)) {
      this.setState({
        lastNameEnError: "姓英語表記が正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate first name
    value = this.state.firstName.trim();
    if (value.length <= 0) {
      this.setState({
        firstNameError: "名は必須項目です。",
      });
      valid = false;
    }

    // Validate first name furi
    value = this.state.firstNameFuri.trim();
    if (value.length <= 0) {
      this.setState({
        firstNameFuriError: "名フリガナは必須項目です。",
      });
      valid = false;
    } else if (!patternFuri.test(value)) {
      this.setState({
        firstNameFuriError: "名フリガナが正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate first name en
    value = this.state.firstNameEn.trim();
    if (value.length <= 0) {
      this.setState({
        firstNameEnError: "名英語表記は必須項目です。",
      });
      valid = false;
    } else if (!patternEn.test(value)) {
      this.setState({
        firstNameEnError: "名英語表記が正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate middle name
    // Validate middle name furi
    value = this.state.middleNameFuri.trim();
    if (value.length > 0) {
      if (!patternFuri.test(value)) {
        this.setState({
          middleNameFuriError: "ミドルネームフリガナが正しく入力されていないか、使用できない文字が含まれています。",
        });
        valid = false;
      }
    }

    // Validate middle name en
    value = this.state.middleNameEn.trim();
    if (value.length > 0) {
      if (!patternEn.test(value)) {
        this.setState({
          middleNameEnError: "ミドルネーム英語表記が正しく入力されていないか、使用できない文字が含まれています。",
        });
        valid = false;
      }
    }

    // Validate birthday
    value = this.state.birthday.trim();
    if (value.length <= 0) {
      this.setState({
        birthdayError: "生年月日は必須項目です。",
      });
      valid = false;
    } else if (isValid(value)) {
      this.setState({
        birthdayError: "生年月日が正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate tel
    value = this.state.tel.trim();
    if (value.length <= 0) {
      this.setState({
        telError: "電話番号は必須項目です。",
      });
      valid = false;
    } else if (!patternPhone.test(value)) {
      this.setState({
        telError: "電話番号が正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate gender
    value = this.state.gender.trim();
    if (value.length <= 0) {
      this.setState({
        genderError: "性別は必須項目です。",
      });
      valid = false;
    }

    // Validate postCode
    value = this.state.postCode.trim();
    if (value.length <= 0) {
      this.setState({
        postCodeError: "郵便番号は必須項目です。",
      });
      valid = false;
    } else if (!patternZipcode.test(value)) {
      this.setState({
        postCodeError: "郵便番号が正しく入力されていないか、使用できない文字が含まれています。",
      });
      valid = false;
    }

    // Validate prefecture
    value = this.state.prefecture.trim();
    if (value.length <= 0) {
      this.setState({
        prefectureError: "都道府県は必須項目です。",
      });
      valid = false;
    }

    // Validate city
    value = this.state.city.trim();
    if (value.length <= 0) {
      this.setState({
        cityError: "市区町村は必須項目です。",
      });
      valid = false;
    }

    // Validate address
    value = this.state.address.trim();
    if (value.length <= 0) {
      this.setState({
        addressError: "町域・番地は必須項目です。",
      });
      valid = false;
    }

    return valid;
  }

  async submit() {
    this.loading(true);
    const validForm = this.valid();
    this.setState({ isValid: validForm });

    if (validForm) {
      const payload = {
        email: this.state.email.trim(),
        lastName: this.state.lastName.trim(),
        lastNameFuri: this.state.lastNameFuri.trim(),
        lastNameEn: this.state.lastNameEn.trim(),
        middleName: this.state.middleName.trim(),
        middleNameFuri: this.state.middleNameFuri.trim(),
        middleNameEn: this.state.middleNameEn.trim(),
        firstName: this.state.firstName.trim(),
        firstNameFuri: this.state.firstNameFuri.trim(),
        firstNameEn: this.state.firstNameEn.trim(),
        birthday: this.state.birthday.trim(),
        postCode: this.state.postCode.trim(),
        tel: this.state.tel.trim(),
        gender: this.state.gender.trim(),
        prefecture: this.state.prefecture.trim(),
        prefectureId: this.state.prefectureId.trim(),
        city: this.state.city.trim(),
        cityId: this.state.cityId.trim(),
        address: this.state.address.trim(),
        building: this.state.building.trim(),
      };
      this.props.saveRegisterTwoocaInput(payload);
      this.setState({
        redirectTo: true,
      });
    } else {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    this.loading(false);
  }

  componentDidMount() {
    this.setState({
      lastName: this.props.registerTwoocaInput?.payload?.lastName ?? "",
      lastNameFuri: this.props.registerTwoocaInput?.payload?.lastNameFuri ?? "",
      lastNameEn: this.props.registerTwoocaInput?.payload?.lastNameEn ?? "",
      firstName: this.props.registerTwoocaInput?.payload?.firstName ?? "",
      firstNameFuri:
        this.props.registerTwoocaInput?.payload?.firstNameFuri ?? "",
      firstNameEn: this.props.registerTwoocaInput?.payload?.firstNameEn ?? "",
      middleName: this.props.registerTwoocaInput?.payload?.middleName ?? "",
      middleNameFuri:
        this.props.registerTwoocaInput?.payload?.middleNameFuri ?? "",
      middleNameEn: this.props.registerTwoocaInput?.payload?.middleNameEn ?? "",
      birthday: this.props.registerTwoocaInput?.payload?.birthday ?? "",
      tel: this.props.registerTwoocaInput?.payload?.tel ?? "",
      gender: this.props.registerTwoocaInput?.payload?.gender ?? "0",
      postCode: this.props.registerTwoocaInput?.payload?.postCode ?? "",
      prefecture: this.props.registerTwoocaInput?.payload?.prefecture ?? "",
      prefectureId: this.props.registerTwoocaInput?.payload?.prefectureId ?? "",
      city: this.props.registerTwoocaInput?.payload?.city ?? "",
      cityId: this.props.registerTwoocaInput?.payload?.cityId ?? "",
      address: this.props.registerTwoocaInput?.payload?.address ?? "",
      building: this.props.registerTwoocaInput?.payload?.building ?? "",
    });

    const filteredCities = this.props.cities.filter(
      (city) => city.prefCode === String(Number(this.state.prefectureId))
    );
    this.setState({
      cities: this.props.cities,
      filteredCities: filteredCities,
    });
    
    // Add script
    const script = document.createElement('script');
    script.src = '/assets/js/app.js';
    script.async = false;
    document.body.appendChild(script);
    this.script = script;
  }

  componentWillUnmount() {
    if (this.script && this.script.parentNode) {
      this.script.parentNode.removeChild(this.script);
    }
  }

  componentDidUpdate() {
    if (this.state.cities !== this.props.cities) {
      const filteredCities = this.props.cities.filter(
        (city) => city.prefCode === String(Number(this.state.prefectureId))
      );
      this.setState({
        cities: this.props.cities,
        filteredCities: filteredCities,
      });
    }
  }

  render() {
    const redirectTo = this.state.redirectTo;
    if (redirectTo === true) {
      let link = addParamUrl("/mypage/twooca/register/confirm", [{}]);
      return <Redirect to={link} />;
    }
    return (
      <div className="twooca bg-white">
        <MetaTags>
          <title>TwooCaアカウント登録・連携</title>
          <meta name="description" content="TwooCaアカウント登録・連携" />
          <meta
            name="twitter:card swiper-slide"
            content="summary_large_image"
          />
          <meta name="twitter:title" content="TwooCaアカウント登録・連携" />
          <meta
            name="twitter:description"
            content="TwooCaアカウント登録・連携"
          />
          <meta
            name="twitter:image"
            content={window.location.origin + "/assets/img/common/ogp.png"}
          />
          <meta name="twitter:site" content="@gochi_meshi" />
          <meta name="twitter:creator" content="@gochi_meshi" />
          <meta name="twitter:image:width" content="300" />
          <meta name="twitter:image:height" content="300" />
          <meta property="og:site_name" content="TwooCaアカウント登録・連携" />
          <meta property="og:title" content="TwooCaアカウント登録・連携" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={window.location.href} />
          <meta
            property="og:image"
            content={window.location.origin + "/assets/img/common/ogp.png"}
          />
          <meta
            property="og:description"
            content={"TwooCaアカウント登録・連携"}
          />
        </MetaTags>
        <Header />
        <main>
          <div className="">
            <div className="fieldset">
              <h1 className="text-center m-0">TwooCaアカウント登録・連携</h1>
            </div>
            <div className="fieldset">
              <p className="m-0">
                TwooCaアカウント登録・連携で必要な情報ご入力・登録ください。
              </p>
            </div>
            {/* Email */}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">メールアドレス</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.emailError
                          ? "input-error"
                          : "")
                      }
                      type="email"
                      readOnly
                      value={this.props.userInfo.email}
                      name="email"
                    />
                  </div>
                  {!this.state.isValid && this.state.emailError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.emailError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="fieldset">
              <div className="twooca-tab">
                <div className="note">
                  <div>
                    <i className="icon-note" />
                  </div>
                  <p>
                    TwooCaとのアカウント連携を正確に行うため、本項目はGOCHIアカウントにご登録のメールアドレスで固定されています。
                    <br />
                    変更をご希望の場合は、先にGOCHIアカウントのプロフィール画面で変更を完了してください。
                  </p>
                </div>
              </div>
            </div>

            {/* Last Name */}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">姓</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.lastNameError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.lastName}
                      name="lastName"
                    />
                  </div>
                  {!this.state.isValid && this.state.lastNameError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.lastNameError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Last Name Furigana*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">姓フリガナ</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.lastNameFuriError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.lastNameFuri}
                      name="lastNameFuri"
                    />
                  </div>
                  {!this.state.isValid && this.state.lastNameFuriError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.lastNameFuriError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Last Name Eng*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">姓英語表記</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.lastNameEnError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.lastNameEn}
                      name="lastNameEn"
                    />
                  </div>
                  {!this.state.isValid && this.state.lastNameEnError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.lastNameEnError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* First Name */}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">名</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.firstNameError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.firstName}
                      name="firstName"
                    />
                  </div>
                  {!this.state.isValid && this.state.firstNameError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.firstNameError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* First Name Furigana*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">名フリガナ</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.firstNameFuriError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.firstNameFuri}
                      name="firstNameFuri"
                    />
                  </div>
                  {!this.state.isValid && this.state.firstNameFuriError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.firstNameFuriError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* First Name Eng*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">名英語表記</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.firstNameEnError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.firstNameEn}
                      name="firstNameEn"
                    />
                  </div>
                  {!this.state.isValid && this.state.firstNameEnError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.firstNameEnError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Middle Name */}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">ミドルネーム</div>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.middleNameError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.middleName}
                      name="middleName"
                    />
                  </div>
                  {!this.state.isValid && this.state.middleNameError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.middleNameError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Middle Name Furigana*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">ミドルネームフリガナ</div>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.middleNameFuriError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.middleNameFuri}
                      name="middleNameFuri"
                    />
                  </div>
                  {!this.state.isValid && this.state.middleNameFuriError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.middleNameFuriError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Middle Name Eng*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">ミドルネーム英語表記</div>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.middleNameEnError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.middleNameEn}
                      name="middleNameEn"
                    />
                  </div>
                  {!this.state.isValid && this.state.middleNameEnError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.middleNameEnError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Birthday */}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">生年月日</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.birthdayError
                          ? "input-error"
                          : "")
                      }
                      type="date"
                      onChange={this.onInputChange}
                      value={this.state.birthday}
                      name="birthday"
                    />
                  </div>
                  {!this.state.isValid && this.state.birthdayError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.birthdayError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Tel*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">電話番号</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.telError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.tel}
                      name="tel"
                    />
                  </div>
                  {!this.state.isValid && this.state.telError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.telError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Gender*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">性別</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <label className="radio-container">
                      <input
                        className={
                          "form-check-input " +
                          (!this.state.isValid && this.state.genderError
                            ? "input-error"
                            : "")
                        }
                        type="radio"
                        onChange={this.onInputChange}
                        value={0}
                        checked={this.state.gender === "0"}
                        name="gender"
                      />
                      <div>男性</div>
                      <span className="checkmark"></span>
                    </label>
                    <label className="radio-container">
                      <input
                        className={
                          "form-check-input " +
                          (!this.state.isValid && this.state.genderError
                            ? "input-error"
                            : "")
                        }
                        type="radio"
                        onChange={this.onInputChange}
                        value={1}
                        checked={this.state.gender === "1"}
                        name="gender"
                      />
                      <div>女性</div>
                      <span className="checkmark"></span>
                    </label>
                    <label className="radio-container">
                      <input
                        className={
                          "form-check-input " +
                          (!this.state.isValid && this.state.genderError
                            ? "input-error"
                            : "")
                        }
                        type="radio"
                        onChange={this.onInputChange}
                        value={2}
                        checked={this.state.gender === "2"}
                        name="gender"
                      />
                      <div>ノンバイナリー</div>
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  {!this.state.isValid && this.state.genderError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-2">
                      {this.state.genderError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Post Code*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">郵便番号</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.postCodeError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.postCode}
                      name="postCode"
                    />
                  </div>
                  {!this.state.isValid && this.state.postCodeError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.postCodeError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Prefecture & City */}
            <div className="fieldset-col">
              <div className="fieldset">
                <div className="fieldset-header">
                  <div className="title">都道府県</div>
                  <em className="fieldset-mark m-0">*必須</em>
                </div>
                <div className="fieldset-body">
                  <div className="field-group field-group-column">
                    <div className="field field-fluid">
                      <select
                        className={
                          "select-box-custom " +
                          (!this.state.isValid && this.state.prefectureError
                            ? "input-error"
                            : "")
                        }
                        value={this.state.prefectureId}
                        name="prefecture"
                        onChange={this.onPrefectureChange}
                      >
                        <option value={""}>選択なし</option>
                        {this.props.prefectures.map((prefecture) => {
                          return (
                            <option
                              value={prefecture.prefectureId}
                              key={prefecture.prefectureId}
                            >
                              {prefecture.prefectureName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {!this.state.isValid && this.state.prefectureError && (
                      <div className="text-danger fs-14 fs-12 text-bold mt-1">
                        {this.state.prefectureError}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="fieldset">
                <div className="fieldset-header">
                  <div className="title">市区町村</div>
                  <em className="fieldset-mark m-0">*必須</em>
                </div>
                <div className="fieldset-body">
                  <div className="field-group field-group-column">
                    <div className="field field-fluid">
                      <select
                        className={
                          "select-box-custom " +
                          (!this.state.isValid && this.state.cityError
                            ? "input-error"
                            : "")
                        }
                        value={this.state.cityId}
                        name="city"
                        onChange={this.onCityChange}
                      >
                        <option value={""}>選択なし</option>
                        {this.state.filteredCities.map((city) => {
                          return (
                            <option key={city.cityId} value={city.cityId}>
                              {city.cityName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {!this.state.isValid && this.state.cityError && (
                      <div className="text-danger fs-14 fs-12 text-bold mt-1">
                        {this.state.cityError}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Address*/}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">町域・番地</div>
                <em className="fieldset-mark m-0">*必須</em>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.addressError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.address}
                      name="address"
                    />
                  </div>
                  {!this.state.isValid && this.state.addressError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.addressError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Address 2 */}
            <div className="fieldset">
              <div className="fieldset-header">
                <div className="title">建物名・部屋番号</div>
              </div>
              <div className="fieldset-body">
                <div className="field-group field-group-column">
                  <div className="field field-fluid">
                    <input
                      className={
                        "form-control " +
                        (!this.state.isValid && this.state.buildingError
                          ? "input-error"
                          : "")
                      }
                      type="text"
                      onChange={this.onInputChange}
                      value={this.state.building}
                      name="building"
                    />
                  </div>
                  {!this.state.isValid && this.state.buildingError && (
                    <div className="text-danger fs-14 fs-12 text-bold mt-1">
                      {this.state.buildingError}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="fieldset policy-box">
              <label>
                <input
                  className="before-icon"
                  type="checkbox"
                  checked={this.state.policy}
                  onChange={(e) => {
                    this.setState({policy: e.target.checked});
                  }}
                />
                <i className="icon" />
              </label>
              <div className="policy-text-description">
                株式会社Kort Valutaのプライバシーポリシーに同意する
                <a href="https://kortvaluta.com/privacy-policy/" target="_blank">
                  https://kortvaluta.com/privacy-policy/
                </a>
              </div>
            </div>

            <div className="fieldset">
              <button
                type="button"
                className="btn btn-rect w-100 button-register-twooca"
                onClick={this.submit}
                disabled={!this.state.policy}
              >
                確認画面へ
              </button>
            </div>
          </div>
        </main>

        <footer className="global-footer footer-mypage">
          <section className="global-footer-nav-area">
            <div className="container">
              <div className="section-header">
                <div className="heading-xs">
                  <div className="title">
                    <h1>
                      <img
                        src="/assets/img/common/logo_gochi_footer.svg"
                        alt="ごちめし"
                        loading="lazy"
                      />
                    </h1>
                  </div>
                </div>
              </div>
              <div className="section-body footer-nav">
                <ul className="footer-link-area">
                  <li>
                    <a href="https://gochimeshi.com/policy/">各種規約</a>
                  </li>
                  <li>
                    <a href="https://gochimeshi.com/policy/privacy/">
                      プライバシーポリシー
                    </a>
                  </li>
                  <li>
                    <a href="https://gochimeshi.com/policy/legal/">
                      特定商取引法に基づく表記
                    </a>
                  </li>
                  <li>
                    <a href="https://user-guide.gochimeshi.com/">
                      よくある質問
                    </a>
                  </li>
                  <li>
                    <a href="https://gochimeshi.com/info/">お問い合わせ</a>
                  </li>
                  <li>
                    <a href="https://www.gigi.tokyo/">
                      運営会社（Gigi株式会社）
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <div className="copyright">
            <small>
              GOCHI®︎ ごちめし®︎ こどもごちめし® 社食ごちめし™︎ ︎ ︎ さきめし®︎
              は、
              <br />
              Gigi株式会社の登録商標です
              <br />
              GOCHIプラットフォームの機能は、
              <br />
              特許取得済み（特許番号：特許第7572763号）
              <br />© Gigi Inc.
            </small>
          </div>
        </footer>
        <LoadingOverlay loading={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  saveUserInfo: (isLogined, isGuest, userInfo) => dispatch(saveUserInfo(isLogined, isGuest, userInfo)),
  saveRegisterTwoocaInput: (payload) => dispatch(saveRegisterTwoocaInput(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RegisterTwooca));
